import { render } from "./Addnew_restaurant.vue?vue&type=template&id=99e927f8&scoped=true"
import script from "./Addnew_restaurant.vue?vue&type=script&lang=js"
export * from "./Addnew_restaurant.vue?vue&type=script&lang=js"

import "./Addnew_restaurant.vue?vue&type=style&index=0&id=99e927f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e927f8"]])

export default __exports__